module.exports = {"cookies":"쿠키","help":"도움말","privacy":"개인정보 보호","signInButtonText":"Adobe ID로 로그인","termsOfUse":"사용 약관","updated":"업데이트됨"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/ko_kr.json
// module id = 949
// module chunks = 0